
import './App.css';
import Counter from './components/Counter';
import Pokemon from './components/Pokemon';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        Counter v2
        <Counter initialValue={10}/>
        <Counter initialValue={20} increment={2}/>
        <Counter initialValue={30} increment={3}/>
        <Counter initialValue={40} increment={4}/>
        <Pokemon />
      </header>
    </div> 
  );
}

export default App;
